import { createEntityAdapter } from '@ngrx/entity';
import { FichierEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<FichierEntityState>;

export const adapter = createEntityAdapter<FichierEntityState>({
  selectId: o => o.idFichier
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const fichierFeatureKey = 'fichier';
